import styled from 'styled-components';
import { themeGet } from '@styled-system/theme-get';

import ShareLinkForm from './ShareLinkForm.jsx';
import { useGetBoard } from './data';
import LoadingComponent from '../../../../shared/LoadingComponent';

const BoardShareSection = styled.div`
  background-color: ${themeGet('colors.white')};
  border: solid 1px ${themeGet('colors.black.10')};
  margin-top: 24px;
  border-radius: 8px;
  width: 635px;
  padding: 16px 24px 24px 24px;
  font-family: Montserrat, sans-serif;
  width: 100%;
  max-width: 635px;
`;

export default function BoardShareLink() {
  const { isLoading, data = { demo: {} } } = useGetBoard();

  return (
    <BoardShareSection>
      {isLoading ? <LoadingComponent /> : <ShareLinkForm demo={data.demo} />}
    </BoardShareSection>
  );
}
